module.exports = __webpack_public_path__ + "static/media/icon-fail.0d896c5a.svg";